module.exports = __webpack_public_path__ + "img/cargando.ddf20667.gif";